// P2: Profile View Modal - Centralized state hook
import { useState, useCallback } from "react";

export function useProfileViewer() {
  const [open, setOpen] = useState(false);
  const [profile, setProfile] = useState(null);
  const [isSelf, setIsSelf] = useState(false);
  const [source, setSource] = useState(null);
  const [onLikeFromProfile, setOnLikeFromProfile] = useState(null);
  const [onPassFromProfile, setOnPassFromProfile] = useState(null);

  const showProfile = useCallback((profileData, options = {}) => {
    setProfile(profileData);
    setIsSelf(!!options.isSelf);
    setSource(options.source || null);
    setOnLikeFromProfile(options.onLikeFromProfile ? () => options.onLikeFromProfile : null);
    setOnPassFromProfile(options.onPassFromProfile ? () => options.onPassFromProfile : null);
    setOpen(true);
  }, []);

  const close = useCallback(() => {
    setOpen(false);
    // Reset callbacks
    setSource(null);
    setOnLikeFromProfile(null);
    setOnPassFromProfile(null);
  }, []);

  return { 
    open, 
    isOpen: open, // Alias for consistency
    profile, 
    isSelf, 
    source,
    onLikeFromProfile,
    onPassFromProfile,
    showProfile, 
    close 
  };
}
